export default __webpack_public_path__ + "static/admin-bogota-b6ba542f61080a8fbe52d3e214fd3cb9.jpg";